export var VERSION = '1.13.4';
//# sourceMappingURL=version.js.map